import { render, staticRenderFns } from "./paginate.vue?vue&type=template&id=db2a3b8c"
import script from "./paginate.vue?vue&type=script&lang=js"
export * from "./paginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports